module.exports = __webpack_public_path__ + "img/this-wicked-fate.d6619506.png";